import { AccountType } from "types/orgTypes";

export const accountTypeValues = [
  "university",
  "updater",
  "hospital",
  "school",
  "optometrist",
  "optician",
  "ophthalmologist",
  "orthoptist",
  "trial",
  "study",
  "nonprofit",
  "other",
  "subscription",
  "rental",
  "congress",
] as const satisfies readonly AccountType[];
